export default "__VITE_ASSET__Bpq$QWt9__"